import { Port } from './Port';
import { Berth } from './Berth';
import { IPropertyEntity } from './IPropertyEntity';

export class Terminal implements IPropertyEntity {
    constructor(
        terminalId: number,
        portId: number,
        port: Port | null,
        terminalShortName: string | null,
        terminalLongName: string | null,
        isPriorityTerminal: boolean,
        terminalIdentity: string | null,
        changedBy: string | null,
        isDeleted: boolean,
        berthArray: Berth[] | null,
        lastUpdated: Date | null
    ) {
        this.terminalId = terminalId;
        this.portId = portId;
        this.port = port;
        this.terminalShortName = terminalShortName;
        this.terminalLongName = terminalLongName;
        this.terminalDisplayName = this.terminalLongName ? this.terminalLongName : this.terminalShortName;
        this.isPriorityTerminal = isPriorityTerminal;
        this.terminalIdentity = terminalIdentity;
        this.isDeleted = isDeleted;
        this.changedBy = changedBy;
        this.pKPortId = portId;
        this.pKBerthId = 0;
        this.pKTerminalId = terminalId;
        this.pKBerthRestrictionId = 0;
        this.berthArray = berthArray;
        this.lastUpdated = lastUpdated;
    }
    terminalId: number;
    portId: number;
    port: Port | null;
    terminalShortName: string | null;
    terminalLongName: string | null;
    terminalDisplayName: string | null;
    isPriorityTerminal: boolean;
    terminalIdentity: string | null;
    isDeleted: boolean;
    changedBy: string | null;
    pKPortId: number;
    pKBerthId: number;
    pKTerminalId: number;
    pKBerthRestrictionId: number;
    berthArray: Berth[] | null;
    lastUpdated: Date | null;
}
